/**
 * Returns a zero left padded string from a number.
 * @param number The number to add padding.
 * @param size The required total length.
 * @return {string} The resulting padded number.
 */
export default function padStart(number, size) {
  let string = String(number);
  while (string.length < (size || 2)) {
    string = "0" + string;
  }
  return string;
}
